import React, { ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { ListTeaserImageProps } from '../Types'
import { ListTeaserImage } from '../Components'
import { ImageIcon } from '../../../../BaseComponents/Image/Components'

const ListTeaserGalleryImage = ({ imageUrl, alt }: ListTeaserImageProps): ReactElement => {
    return (
        <Grid noExpand width={94} height={94} position="relative">
            <ListTeaserImage imageUrl={imageUrl} alt={alt} />
            <ImageIcon size="XS" type="gallery-active" position="bottom-left" />
        </Grid>
    )
}

export default ListTeaserGalleryImage
